import React from 'react';
import Designation from '../../components/master/Designation';
import PageLayout from '../../components/PageLayout';

interface MasterPageProps {
  onLogout?: () => void;
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

const DesignationPage: React.FC<MasterPageProps> = ({ onLogout, currentPage, onNavigate }) => {

  return (
    <PageLayout onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate}>
      <Designation />
    </PageLayout>
  );
};

export default DesignationPage;
